export { AnalyzeRisks as AnalyzeRisksButton } from './AnalyzeRisks';
